import axios from 'axios';
import { BASE_URL_ADDR } from '../Constants/BaseURL';

// axios.defaults.baseURL = ;
export const axiosInstance = axios.create({
  baseURL: BASE_URL_ADDR,
  timeout: 120000
})
// axios.defaults.baseURL = 'http://localhost:8000';

axiosInstance.interceptors.request.use(function (config:any) {
  // Do something before request is sent
  config.headers['Content-Type'] = 'application/json';
  config.headers.common.Accept = 'application/json';
  config.headers['Access-Control-Allow-Origin'] = "*";
  // console.log("heeeeehehehehhehheader", config)
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// section superadmin
const applicantsService = {
  index: async (data:{nin: number; phone:string; email:string; candidateRole: string}) => {
    return await axiosInstance.post(`/recruitment/nin-enquiry?module=portal&admissionId=4`, data);
  },
  resume: async (data: any) => {
    return await axiosInstance.post(`/recruitment/resume-submission?admissionId=4`, data);
  },

  preview: async (nin:number) => {
    return await axiosInstance.post(`/recruitment/verify-bio-data-before-submission?module=portal&admissionId=4&nin=${nin}`, { nin });
  },
  validate: async (nin:number, data: any) => {
    return await axiosInstance.post(`/recruitment/validate-submission?admissionId=4&nin=${nin}`, data);
  },
  crsync: async (nin:number) => {
    return await axiosInstance.post(`/recruitment/initiate-cloud-sync?admissionId=4&nin=${nin}`, {});
  },
  finalSubmission: async (data: {hashNIN: string, hashSubmission: string}) => {
    return await axiosInstance.post('/recruitment/make-final-submission?admissionId=4', data)
  },
  // resume: async (data: {nin: string, rrr: string}) => {
  //   return await axios.get(`/recruitment/resume?nin=${data.nin}&rrr=${data.rrr}&module=portal&admissionId=4`,);
  // },
  admissionSettings: async () => {
    return await axiosInstance.get(`/cpanel/admission-settings`);
  },
  jobVacancies: async () => {
    return await axiosInstance.get(`/recruitment/vacancy-enquiry?admissionId=4`);
  },
  search: async (nin: number) => {
    return await axiosInstance.get(`/recruitment/nimc/extract-nin?nin=${nin}&module=portal&admissionId=4`);
  },

  uploadFile: async (data:{document:any, nin:number, documentType:string}) => {
    return await axiosInstance.post(`/recruitment/upload-credentials?module=portal&admissionId=4`, data);
  },
  getRrr: async (data:{nin:number}) => {
    return await axiosInstance.get(`/recruitment/request-tranx-info?nin=${data.nin}&module=portal&admissionId=4`);
  },
  pscreeningSlip: async (data:{nin:number}, admissionId:number) => {
    return await axiosInstance.get(`/query-pscreen-status?nin=${data.nin}&admissionId=${admissionId}`)
  },
  pscreeningCredForm: async (data:{nin:number}, admissionId:number) => {
    return await axiosInstance.get(`/request-pscreen-status?nin=${data.nin}&admissionId=${admissionId}`)
  },

}

export default applicantsService
